export const webSocket = {
  openConnection,
  closeConnection
}

function openConnection(url, request, handleMessage = () => { }, handleError = () => { }) {
  let ws = new WebSocket(url);
  ws.onopen = () => {
    ws.send(JSON.stringify(request));
  };
  ws.onmessage = function (event) {
    handleMessage(event);
  }
  ws.onerror = err => {
    handleError(err)
  }
  return ws;
}

function closeConnection(ws) {
  ws.close();
}

